import React from 'react';
import { Button } from 'antd';
import { QRCodeCanvas } from 'qrcode.react';

import Divider from '@src/components/Divider';
import IntlMessages from '@src/util/IntlMessages';
import { useIsMobile } from '@src/packages/utils';
import completingSvg from 'assets/images/illustrations/completing.svg';

const OPERONDA_APP_URL = 'https://play.google.com/store/apps/details?id=com.guarnic.operonda&pcampaignid=web_share';
export default function ResetPasswordSuccessful() {
  const { isMobile } = useIsMobile();
  return (
    <>
      <div className="gx-flex-column gx-align-items-center">
        <img width={170} height={170} src={completingSvg} />
        <div className="gx-mt-4 gx-fs-xl">
          <IntlMessages id="app.userAuth.password.reset.successful" />
        </div>
      </div>
      {isMobile ? (
        <>
          <div className="gx-flex-column gx-align-items-center">
            <Divider className="gx-m-0">
              <IntlMessages id="app.userAuth.are.you.admin" />
            </Divider>
            <Button href={`${window.location.origin}/signin`} type="default" block className="gx-mt-4">
              <IntlMessages id="app.userAuth.enter.portal.admin" />
            </Button>
            <Divider className="gx-m-0">
              <span className="gx-fs-lg">
                <IntlMessages id="app.userAuth.download.app.sugerence" />
              </span>
            </Divider>
            <Button href={OPERONDA_APP_URL} type="primary" block className="gx-mt-4">
              <IntlMessages id="app.userAuth.download.app" />
            </Button>
          </div>
        </>
      ) : (
        <>
          <div className="gx-ml-2 gx-mr-2 gx-mt-1">
            <Divider />
          </div>
          <div className="gx-flex-column gx-align-items-center">
            <QRCodeCanvas size={246} value={OPERONDA_APP_URL} />

            <span className="gx-mt-4 gx-fs-lg">
              <IntlMessages id="app.userAuth.download.app.qr" />
            </span>

            <Divider className="gx-mb-2">
              <span className="gx-fs-lg">
                <IntlMessages id="app.userAuth.are.you.admin" />
              </span>
            </Divider>

            <Button href={`${window.location.origin}/signin`} type="default" block className="gx-mt-4">
              <IntlMessages id="app.userAuth.enter.portal.admin" />
            </Button>
          </div>
        </>
      )}
    </>
  );
}
